import { ExclamationPointIcon } from '@/assets/icons/ExclamationPointIcon';
import { VALIDITY } from '@/constants/validity';
import cn from 'classnames';
import styles from './invalid.module.scss';
import { TrianglePointIcon } from '@/assets/icons/TrianglePointIcon';

export interface Props {
    children: React.ReactNode;
    className?: string;
    style?: { [index: string]: string | number };
    validState: FieldValidityState;
    errorId?: string;
    dataCy?: string;
    theme?: string;
}

export function InvalidFeedback(props: Props): React.JSX.Element {
    const classNames = cn(styles.invalidFeedback, {
        [styles.hide]: props.validState !== VALIDITY.invalid,
    });

    if (props.theme === 'round') {
        return (
            <div
                id={props.errorId}
                className={cn(styles.invalidFeedbackRound, { [styles.hide]: props.validState !== VALIDITY.invalid })}
                style={props.style}
                role="alert"
                data-cy={props?.dataCy}
            >
                <ExclamationPointIcon aria-label="Error:" />
                {props.children}
            </div>
        );
    }

    return (
        <div id={props.errorId} className={classNames} style={props.style} role="alert" data-cy={props?.dataCy}>
            <TrianglePointIcon aria-label="Error:" />
            {props.children}
        </div>
    );
}
